export default [
    //'home',
    //'checkin',
    //'shop',
    //'shops',
    //'cart',
    //'shop.products',
    //'shop.services',
    'order',
    'orders',
    'order.detail',
    'checkout.done',
    'services.checkout',
    //'services.order.summary'
]


// WEBPACK FOOTER //
// ./src/router/routes/private.js